import PropTypes from 'prop-types';

const isObject = obj => {
  return Object.prototype.toString.call(obj) == '[object Object]';
};

const priceMap = (props, propName, componentName) => {
  const error = new Error(
    `Invalid prop values \`${propName}\` supplied to` +
      ` \`${componentName}\`. Validation failed.`
  );

  const priceMap = props[propName] || {};

  const allValid = (list, validator) => {
    for (const item of list) {
      const componentName = validator.toString(),
        propName = '_',
        props = { [propName]: item },
        isInvalid = validator(props, propName, componentName);

      if (typeof isInvalid !== 'undefined') {
        return false;
      }
    }

    return true;
  };

  if (!isObject(priceMap) || !allValid(Object.values(priceMap), priceList)) {
    return error;
  }
};

const priceList = (props, propName, componentName) => {
  const error = new Error(
    `Invalid prop values \`${propName}\` supplied to` +
      ` \`${componentName}\`. Validation failed.`
  );

  const priceList = props[propName] || {};

  const allOfType = (list, expectedType) => {
    for (const item of list) {
      if (typeof item !== expectedType) {
        return false;
      }
    }

    return true;
  };

  if (!isObject(priceList) || !allOfType(Object.values(priceList), 'number')) {
    return error;
  }
};

const CoercedSelectValue = PropTypes.oneOfType([
  PropTypes.number, // from a serialiser
  PropTypes.string, // from the `value` of a <Select>
]);

const productOption = PropTypes.shape({
  key: PropTypes.string,
  finish: PropTypes.shape({
    name: PropTypes.string,
    title: PropTypes.string,
  }),
  border: PropTypes.bool,
  standard_product_code: PropTypes.string,
  delivery_options: PropTypes.arrayOf(PropTypes.number),
});

const PhotoDimensions = PropTypes.shape({
  w: PropTypes.number,
  h: PropTypes.number,
});

const UploadedPhoto = PropTypes.shape({
  id: PropTypes.number,
  image_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  root_image_id: PropTypes.number,
  uploaded: PropTypes.bool,
  source: PropTypes.string,
  filesize: PropTypes.oneOfType([PropTypes.number]),
  filename: PropTypes.string,
  quantity: PropTypes.number,
  crop: PropTypes.arrayOf(PropTypes.number),
  fx: PropTypes.string,
  gamma: PropTypes.number,
  colour_fx: PropTypes.string,
  angle: PropTypes.number,
  straighten: PropTypes.number,
  raw_dimensions: PhotoDimensions,
  large_dimensions: PhotoDimensions,
  thumb_dimensions: PhotoDimensions,
  raw_url: PropTypes.string,
  large_url: PropTypes.string,
  thumb_url: PropTypes.string,
  blurhash: PropTypes.string,
  client_uuid: PropTypes.string.isRequired,
  sizeKey: PropTypes.string.isRequired,
});

const DeliveryOption = PropTypes.shape({
  analytics_id: PropTypes.string,
  code: PropTypes.string,
  key: CoercedSelectValue,
  time_hours: CoercedSelectValue,
  timescale: PropTypes.string,
  title: PropTypes.string,
  mobile_title: PropTypes.string,
  type: PropTypes.string,
});

const PrintFinish = PropTypes.shape({
  key: CoercedSelectValue,
  name: PropTypes.string,
  title: PropTypes.string,
});

const PrintSize = PropTypes.shape({
  key: PropTypes.string,
  size_id: PropTypes.string,
  title: PropTypes.string,
  default: PropTypes.bool,
  area: PropTypes.arrayOf(PropTypes.number),
  options: productOption,
  prices: priceMap,
  photos: PropTypes.arrayOf(UploadedPhoto),
});

const PrintsBuilderUrlsShape = PropTypes.shape({
  data: PropTypes.string.isRequired, // json data of available prints config
  add_to_cart: PropTypes.string.isRequired, // update current order with print details
  basket: PropTypes.string.isRequired, // json data of whats in the basket
  upload: PropTypes.string.isRequired, // file upload
  upload_from_album: PropTypes.string.isRequired, // album upload
  cart_page: PropTypes.string.isRequired, // url of page to nav to from prints builder
});

const FeaturesShape = PropTypes.shape({
  browserImageCompression: PropTypes.bool,
  browserCompressionLevel: PropTypes.string,
  printsBuilderDuplicateDetectionDisabled: PropTypes.bool,
  printsBuilderBlurhashDisabled: PropTypes.bool,
  pricesPopup: PropTypes.bool,
  allowMultiplePrintFinishesPerOrder: PropTypes.bool,
  disableAutoPrintCropping: PropTypes.bool,
  printsBuilderSetDefaultCropTopAligned: PropTypes.bool,
  mobile: PropTypes.bool,
  debugEnabled: PropTypes.bool,
});

export {
  DeliveryOption,
  PrintFinish,
  PrintSize,
  PhotoDimensions,
  CoercedSelectValue,
  UploadedPhoto,
  PrintsBuilderUrlsShape,
  FeaturesShape,
  // exported for testing
  priceMap as _priceMap,
  priceList as _priceList,
};
